
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nails/tag/[tag]",
      function () {
        return require("private-next-pages/nails/tag/[tag].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nails/tag/[tag]"])
      });
    }
  